import { useMemo } from "react"

import { isFunction } from "lodash"

import ColoredTag, { TagColors } from "./ColoredTag"
import CompactedList from "./CompactedList"

const CompactedTagList = ({ items, getter, label, numberToShow, overflowTagColor = TagColors.GEEKBLUE }) => {
  const values = useMemo(() => (isFunction(getter) ? getter(items) : items).map(item => item[label]), [items, label, getter])

  return (
    <CompactedList
      items={values}
      overflowTagColor={overflowTagColor}
      component={ColoredTag}
      overflow={numberToShow}
    />
  )
}


export default CompactedTagList